import { Component, OnInit, ViewChild } from '@angular/core';
import { Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
// import { NotificationsService } from 'angular2-notifications';
import { BaseDataService, BaseUpdateComponent, DropdownPicklistComponent, NotificationService } from 'yt-ng-framework';
import { KomitentView } from '../komitent/komitent-view';
import { OsobaView } from '../osoba/osoba-view';
import { KomitentKontaktOsoba } from './komitent-kontakt-osoba';
// import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'yt-komitent-kontakt-osoba-update',
  templateUrl: './komitent-kontakt-osoba-update.component.html'
})
export class KomitentKontaktOsobaUpdateComponent extends BaseUpdateComponent<KomitentKontaktOsoba> implements OnInit {

  @ViewChild('cmbKomitent', { static: true }) cmbKomitent : DropdownPicklistComponent<KomitentView>;
  @ViewChild('cmbOsoba', { static: true }) cmbOsoba : DropdownPicklistComponent<OsobaView>;

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected baseDataService: BaseDataService,
    // protected notificationsService: NotificationsService,
    protected toastrService: NotificationService,
    protected translateService: TranslateService,
    
  ) {
    super(
      activatedRoute,
      baseDataService,
      toastrService,
      translateService
    );
  }

  ngOnInit() {
    this.addValidatorToFc("KomitentID",Validators.required,"required","KOMITENTKONTAKTOSOBA.KOMITENT.VALIDATION.REQUIRED");
    this.addValidatorToFc("OsobaID",Validators.required,"required","KOMITENTKONTAKTOSOBA.OSOBAID.VALIDATION.REQUIRED");
    this.addValidatorToFc("Opis",Validators.maxLength(250),"maxlength","KOMITENTKONTAKTOSOBA.OSOBAID.VALIDATION.MAXLENGTH");


  }

  ngAfterViewInit(){
    if (this.ParentProperty) {
      setTimeout(() => {
        this.baseFormGroup.patchValue({ KomitentID: this.ParentProperty.Value });
        this.baseFormGroup.get("KomitentID").disable();
        this.cmbOsoba.focus();
      },0)

    }
    else 
      this.cmbKomitent.focus();     
  }
}
